var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"relative",class:{
        'cursor-not-allowed opacity-50': _vm.disabled,
        'cursor-wait': _vm.submitting
    },attrs:{"disabled":_vm.disabled,"type":"submit"}},[_c('span',{class:{'invisible': _vm.submitting}},[_vm._t("default")],2),_vm._v(" "),(_vm.submitting)?_c('span',{staticClass:"block absolute inset-0 flex justify-center items-center"},[_c('font-awesome-icon',{attrs:{"spin":true,"icon":"spinner"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }